<template>
  <div class="onboarding-desktop-wrapper">
    <div
      v-show="curOnboardingIndex === -1"
      class="onboarding-popup"
    >
      <span
        class="icon ic-modal-close"
        @click="handleClickClose"
      />
      <h1>환영합니다!</h1>
      <div class="description">
        피플박스 이용 전 기본 설정이 필요합니다. <br>
        아래 버튼을 눌러 가이드를 따라 <br>
        기본 설정을 마쳐주시길 바랍니다.
      </div>
      <el-button
        class="light-gray"
        @click="handleClickNext"
      >
        기본 설정 가이드 시작
      </el-button>
    </div>

    <div
      v-show="curOnboardingIndex === onboardingContents.length"
      class="onboarding-popup"
    >
      <span
        class="icon ic-modal-close"
        @click="handleClickClose"
      />
      <h1>이제 시작해보세요!</h1>
      <div class="description">
        회원 50인까지 전 기능 무료 이용이 가능합니다. <br>
        이용 중 문의 사항은 언제든지 <br>
        좌측 하단 '지원' 버튼을 눌러 접수해주세요.
      </div>
      <el-button
        class="light-gray"
        style="margin-bottom: 10px;"
        @click="goFirstSetting"
      >
        기본 설정하러 가기
      </el-button>
      <div
        class="btn-goback"
        @click="curOnboardingIndex = 0"
      >
        가이드 처음부터 다시 보기
      </div>
    </div>

    <div
      v-for="(onboardingContent, contentIndex) in onboardingContents"
      v-show="contentIndex === curOnboardingIndex"
      :style="{top: onboardingContent.top + 'px'}"
      class="onboarding__point-location"
    >
      <div class="onboarding__point" />
      <div class="onboarding__point-modal">
        <h3
          v-html="onboardingContent.title"
        />
        <span
          class="onboarding__description"
          v-html="onboardingContent.description"
        />
        <div class="onboarding__control">
          <el-button
            v-show="contentIndex !== 0"
            class="inverted-black"
            @click="handleClickPrev"
          >
            이전
          </el-button>
          <el-button
            v-if="contentIndex < (onboardingContents.length - 1)"
            class="light-gray"
            @click="handleClickNext"
          >
            다음
          </el-button>
          <el-button
            v-else
            class="light-gray"
            @click="handleClickNext"
          >
            완료
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: "OnboardingDesktop",
	data() {
		return {
			curOnboardingIndex: -1,
			onboardingContents: [
				{
					top: 469,
					pagePath: "/setting/policy",
					title: `① <strong>운영 정책</strong>을 설정해주세요.`,
					description:
						"현재 운영 중인 정책을 피플박스 기본 시스템으로 설정해주시길 바랍니다. 예약제가 아닐 경우 이 단계는 스킵하시면 됩니다.",
				},
				{
					top: 619,
					pagePath: "/setting/instructor",
					title: `② <strong>강사</strong> 정보를 등록해주세요.`,
					description:
						"수업을 담당하는 모든 강사의 정보를 입력해주시길 바랍니다. 해당 정보는 수업에 함께 표기되어 회원에게 보여질 예정입니다.",
				},
				{
					top: 569,
					pagePath: "/setting/membership",
					title: `③ <strong>회원권</strong>을 등록해주세요.`,
					description:
						"회원이 구매하고 이용할 모든 회원권을 등록해주세요. 회원은 배정받은 회원권 정책대로 수업을 참가할 수 있습니다.",
				},
				{
					top: 519,
					pagePath: "/setting/course",
					title: `④ <strong>수업</strong>을 개설해주세요.`,
					description:
						"스케줄에 등록할 모든 수업을 개설해주세요. 수업을 보다 편리하게 조회 및 관리할 수 있도록 카테고리를 적극 활용하시길 바랍니다.",
				},
				{
					top: 136,
					pagePath: "/schedule",
					title: `⑤ <strong>스케줄</strong>을 등록해주세요. `,
					description:
						"수업을 개설한 후 스케줄을 등록해주세요. 스케줄 내 ‘누구나 수강 가능’한 수업은 모든 회원에게, ‘수강 제한’이 있는 수업은 해당 수업을 배정받은 특정 회원에게만 표시됩니다. ",
				},
				{
					top: 396,
					pagePath: "/member/register",
					title: `⑥ 마지막으로 <strong>회원</strong>을 등록해주세요.`,
					description:
						"회원 등록은 본 페이지에서 관리자가 회원을 등록하거나, 피플박스 앱을 통해 회원이 직접 가입하는 두 가지 방법이 있습니다. 앱으로 회원 가입하는 방법은 <a href='https://intercom.help/fiflbox/ko/articles/3153313-%ED%94%BC%ED%94%8C%EB%B0%95%EC%8A%A4-%EC%95%B1-%EA%B0%80%EC%9D%B4%EB%93%9C' target='_blank'>이 링크</a>를 확인해주세요.",
				},
			],
		};
	},
	watch: {
		curOnboardingIndex: {
			handler(index) {
				if (index < 0 || index === this.onboardingContents.length) {
					this.$router.push("/dashboard").catch(()=>{});
				} else {
					this.$router.push(this.onboardingContents[index].pagePath).catch(()=>{});
				}

				this.isSideMenuCollapsed = false;
			},
		},
	},
	created() {
		document.querySelector("html").scrollTop = 0;
	},
	methods: {
		handleClickPrev() {
			if (this.curOnboardingIndex > 0) {
				this.curOnboardingIndex--;
			}
		},
		handleClickNext() {
			if (this.curOnboardingIndex < this.onboardingContents.length) {
				this.curOnboardingIndex++;
			} else if (this.curOnboardingIndex === this.onboardingContents.length) {
				this.$localStore.setValue("onboarding", "done");
			}
		},
		handleClickClose() {
			this.$localStore.setValue("onboarding", "done");
			this.$emit("close");
			this.$router.push("/dashboard").catch(()=>{});
		},
		goFirstSetting() {
			this.$localStore.setValue("onboarding", "done");
			this.$emit("close");
			this.$router.push("/setting/policy").catch(()=>{});
		},
	},
};
</script>

<style lang="scss">
.onboarding-desktop-wrapper {
	position: fixed;
	width: 100%;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.27);
	z-index: 99999;
	display: flex;
	align-items: center;
	justify-content: center;

	.onboarding__point-location {
		position: absolute;
		left: 175px;
	}

	.onboarding-popup {
		width: 425px;
		height: 290px;
		flex: initial;
		padding: 50px 0;
		box-sizing: border-box;
		border-radius: 16px;
		box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
		background-color: #4a4a4a;
		color: #ffffff;
		text-align: center;
		position: relative;

		.ic-modal-close {
			position: absolute;
			top: 15px;
			right: 15px;
			cursor: pointer;
		}

		h1 {
			line-height: 37px;
			font-size: 25px;
			font-weight: 300;
			letter-spacing: -1px;
			text-align: center;
			margin-bottom: 20px;
		}

		div.description {
			font-size: 15px;
			font-weight: normal;
			line-height: 22px;
			letter-spacing: -0.8px;
			text-align: center;
			color: #ffffff;
			margin-bottom: 25px;
		}

		div.btn-goback {
			text-decoration: underline;
			text-underline: white;
			font-size: 11px;
			font-weight: 500;
			line-height: 20px;
			letter-spacing: -0.6px;
			cursor: pointer;
		}
	}

	.onboarding__point {
		width: 15px;
		height: 15px;
		background-color: #4a4a4a;
		border-radius: 15px;

		&::after {
			content: "";
			display: block;
			position: absolute;
			top: 6px;
			left: 13px;
			width: 25px;
			height: 3px;
			background-color: #4a4a4a;
		}
	}

	.onboarding__point-modal {
		position: absolute;
		top: -18px;
		left: calc(15px + 18px);

		width: 425px;
		padding: 20px 20px 15px;
		box-sizing: border-box;
		border-radius: 16px;
		box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
		background-color: #4a4a4a;

		h3 {
			margin: 0 0 10px;
			line-height: 25px;
			font-size: 17px;
			letter-spacing: -0.8px;
			color: #ffffff;
			font-weight: normal;
		}

		span.onboarding__description {
			font-size: 15px;
			letter-spacing: -0.8px;
			color: #ffffff;

			a {
				color: #ffffff;
				text-underline: #ffffff;
			}
		}

		.onboarding__control {
			margin-top: 20px;
			/*float: right;*/
			text-align: right;
		}
	}
}
</style>
